import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import './Style.scss'
import LinkOnly from './LinkOnly';


const TextLeftImage = ({ articleObj }) => {
    var content = articleObj;
    return (
        <>
            {/* <div className={`${content.attributes.articleRendering}      ${content.attributes.class}`} data-type="TextLeftImage" 
				style={content.attributes.articlePadding?{padding:`${content.attributes.articleContainerPadding}`}:{}}	>
                    <div className='card-design flex'>
                    {content.title ?
                    <div className='card-text' dangerouslySetInnerHTML={{__html: content.title}}></div>
                    :""}
                    {content.body ?
                    <div className='card-body' dangerouslySetInnerHTML={{__html: content.body}}> </div>
                    :""}
                        {content.attributes.mainImageUrl ? 
                            <Link target={content.attributes.openLinkInNewTabYn === "true" ? "_blank" : ""} 
                                to={content.attributes.mainImageUrl}>  
                                <img src={`${content.mainImage}`} className='img-fluid' alt={content.attributes.altText} />
                            </Link>
                                : 
                        <img src={`${content.mainImage}`} className={`img-fluid ${content.attributes.imageRendering}`} alt={content.attributes.altText} />
                }
                    </div>
                </div> */}

            <div className={`${content.attributes.articleRendering}      ${content.attributes.class}`} data-type="TextLeftImage"
                style={content.attributes.articlePadding ? { padding: `${content.attributes.articleContainerPadding}` } : {}}	>
                <div className='card-design d-flex'>
                    {content.attributes.mainImageUrl ?
                        <Link target={content.attributes.openLinkInNewTabYn === "true" ? "_blank" : ""}
                            to={content.attributes.mainImageUrl}>
                            <img src={`${content.mainImage ? content.mainImage : ""}`} fetchpriority="high" className='img-fluid' alt={content.attributes.altText} />
                        </Link>
                        :
                        <img src={`${content.mainImage ? content.mainImage : ""}`} fetchpriority="high" className={`img-fluid ${content.attributes.imageRendering}`} alt={content.attributes.altText} />
                    }

                    {content.title ?
                        <p className='card-text' dangerouslySetInnerHTML={{ __html: content.title }}></p>
                        : ""}
                    {content.body ?
                        <div className='card-body' dangerouslySetInnerHTML={{ __html: content.body }}></div>
                        : ""}
                    {content.attributes.linkName ? <LinkOnly articleObj={content} /> : ""}
                </div>
            </div>
        </>
    )
}

export default TextLeftImage